<app-dialog-container
  title="{{ modalTitle | translate }}"
  (confirmButtonHandler)="save()"
  [isValid]="data.form.valid"
  [confirmButtonText]="saveButtonTexts[data.modalType]"
  [createPrivilege]="Privileges.MenuCreate"
  [editPrivilege]="Privileges.MenuUpdate"
  [deletePrivilege]="Privileges.MenuDelete"
  [adminPrivilege]="data.adminPrivilege"
>
  <form [formGroup]="data.form">
    <div class="row-container">
      <app-ui-input
        id="menu-item-name"
        label="{{ 'name' | translate }}"
        type="text"
        [control]="data.form.name"
        [required]="true"
      ></app-ui-input>
      <app-ui-select
        id="menu-item-placement"
        label="{{ 'placement' | translate }}"
        [control]="data.form.parentId"
        [options]="possibleLocationsList"
        [required]="true"
        [isMultiple]="false"
      ></app-ui-select>
      <app-ui-autocomplete
        id="menu-item-icon"
        label="{{ 'icon' | translate }}"
        [options]="icons"
        [initialValue]="data.form.icon.value"
        [searchTerm]="data.form.icon"
        [renderIcons]="true"
      ></app-ui-autocomplete>
    </div>
    @if (data.modalType === MenuTreeButtonAction.Delete && data?.items?.length) {
      <mat-card>
        <div class="row-container">
          <h2>{{ modalDescription | translate }}</h2>
        </div>
        <div class="row-container">
          @for (item of data.items; track item) {
            <app-menu-tree-single
              [item]="item"
              [showFunctionalButtons]="false"
            ></app-menu-tree-single>
          }
        </div>
      </mat-card>
    }
  </form>
</app-dialog-container>
